import em from "../bl/event";

export default {
    install(Vue) {
        // Inject event manager
        Vue.prototype.$event = em;
    }
};
